export default function getParameterByName(paramName) {
  const url = window.location.href;
  const nameProc = paramName.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${nameProc}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



// WEBPACK FOOTER //
// ./src/utils/query-params.js